import { Link } from "react-router-dom";
import { categories, navItems, siteInfo } from "@/mocks/site";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-20 bg-primary-950 text-primary-50">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 md:px-6 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-flower-fill text-lg" aria-hidden="true"></i>
            </span>
            <span className="font-heading text-lg font-700">{siteInfo.name}</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-100/80">
            {siteInfo.intro}
          </p>
          <p className="mt-5 flex items-center gap-2 text-sm text-primary-100/80">
            <i className="ri-mail-line" aria-hidden="true"></i>
            <a href={`mailto:${siteInfo.email}`} className="hover:text-background-50">
              {siteInfo.email}
            </a>
          </p>
        </div>

        <div>
          <h2 className="font-heading text-base font-600 text-background-50">站内导航</h2>
          <ul className="mt-4 space-y-2.5 text-sm">
            {navItems.map((item) => (
              <li key={item.to}>
                <Link to={item.to} className="text-primary-100/80 transition-colors hover:text-background-50">
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h2 className="font-heading text-base font-600 text-background-50">内容分类</h2>
          <ul className="mt-4 space-y-2.5 text-sm">
            {categories.map((cat) => (
              <li key={cat.id}>
                <Link
                  to={`/works?category=${cat.id}`}
                  className="text-primary-100/80 transition-colors hover:text-background-50"
                >
                  {cat.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-900/60">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-6 text-xs text-primary-100/70 sm:flex-row md:px-6">
          <p>© {year} {siteInfo.name} · 本站内容为原创介绍与推荐，不提供在线播放</p>
          <p>内容仅供学习与交流，转载请注明来源</p>
        </div>
      </div>
    </footer>
  );
}